export const VERSION = '0.0.0';
export const COMMIT_SHORT_SHA = 'cb24d5fd';
